import { Link } from "react-router-dom";
import { API_BASE_URL, formatDuration, openInGoogleMaps } from "../../utils";
import "./TableBidCard.css";
import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import buffe from "../image/buffe.png";
import { IoLocationOutline } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";

import { BiDrink } from "react-icons/bi";
import TextRoller from "./TextRoller";
import PlatformChargesTooltip from "./PlatformChargesTooltip";
import ShareModal from "../../Feed Page/custom-comp/ShareModal";
import { useState } from "react";
import { CiHeart } from "react-icons/ci";
import { HiOutlineLocationMarker } from "react-icons/hi";
import MoreFeatureShow from "./MoreFeatureShow";
import { MdRestaurant } from "react-icons/md";
import { BiSolidDrink } from "react-icons/bi";

const url = `${API_BASE_URL}/master/assets/uploads/`;

const data = {
  id: 101,
  club_id: 710,
  club_slug: "club-illusion",
  clubName: "Club Illusion",
  clubLogo: "club-illusion.jpg",
  club_address: "Connaught Place, New Delhi",
  distance: 5.3,
  title: "Unlimited Buffet + Drinks Night",
  discount: 1200,
  mrp: 3999,
  price: 2799,
  kids_price: 999,
  foodserving: "120 hours 30 minutes",
  alcoholserving: " 120 hours 30 minutes",
  profile_pic: "default-avatar.png",
  event_date: "2025-10-15",
  inclusion: {
    package_name: "Premium Night Party",
    welcome_drink: "mocktails ",
    buffet: "Veg & Non-Veg",
    dance_floor: "Yes",
    couple_entry: "Allowed",
    parking: "Free valet available",
  },
  name: "Illusion Lounge",
};


export default function TableBidCard({ isFiltered }) {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareTitle, setShareTitle] = useState("");
  const [currentShareUrl, setCurrentShareUrl] = useState("");
  const [showMoreModal, setShowMoreModal] = useState(false);


  const format = (str) =>
    str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";
  function generateClubUrl(clubName, cityName, areaName, title) {
    const format = (str) =>
      str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";

    return `/party-package/${format(clubName)}-${format(cityName)}-${format(
      areaName
    )}/${format(title)}`;
  }

  function generateClubDetailUrl(clubName, cityName, areaName, title) {
    const format = (str) =>
      str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";

    return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
  }

  const messages = [
    `choose this Now! ₹${data?.discount} would be Saved Instantly on This Booking!`,
    `choose this Now! ₹${data?.discount} would be Saved Instantly !`,
  ];

  const BidDetailUrl = (clubSlug, title, id) => {
    return `${API_BASE_URL}/bid-detail/${format(clubSlug)}/${format(
      title
    )}/${id}`;
  };

  const generateEventUrl = (slug1, slug2) => {
    return `${API_BASE_URL}/event/${slug1}/${slug2}`;
  };

  const handleShare = (e, eventData) => {
    e.preventDefault();
    e.stopPropagation();

    let url = BidDetailUrl(eventData.club_slug, eventData.title, eventData.id);

    setCurrentShareUrl(url);
    setShareTitle(
      `Check out ${eventData.clubName}${eventData.title ? " - " + eventData.title : ""
      }`
    );
    setIsShareModalOpen(true);
  };

  return (
    <>
      <div className="table-new-card">

        <div className='event-new-card-image-section position-relative' style={{
          backgroundImage: `url(${(url + data?.clubLogo || "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww")})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'
        }} >
          <div className='event-detail-page-design-content1-img-blur-overlay'>

            <div className='icon-seton-image'>
              <div className='d-flex gap-2'>
                <div className='pnats-icon-wrapper-icon-desktop icon cursor-pointer' onClick={(e) => handleShare(e, data)}>
                  <CiHeart size={22} />
                </div>
                <div className='pnats-icon-wrapper-icon-mobile icon cursor-pointer ' onClick={(e) => handleShare(e, data)}>
                  <PiShareFatLight size={22} />
                </div>
              </div>
            </div>
            <img
              src={url + data?.clubLogo}
              alt=""
              onError={(e) => {
                e.target.onerror = null; // prevent infinite loop
                e.target.src =
                  "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
              }}
            />

          </div>

        </div>

        <div className="table-new-card-image-section-wrapper">
          <div className="table-new-card-content-section">
            <div className="table-new-card-text-section-wrapper">
              <div className="table-new-card-text-section">
                <h1>
                  <span className="table-new-card-img-icon-section-logo">
                    <img
                      src={
                        data?.clubLogo
                          ? url + data.clubLogo
                          : url + data?.profile_pic
                      }
                      alt=""
                    />
                  </span>{" "}
                  {data?.clubName || data?.name}
                </h1>

                <div className="table-new-card-text-section-location">
                  <p>
                    <span className="icon-size-set">
                      <HiOutlineLocationMarker />
                    </span>{" "}
                    {data?.club_address?.length > 24
                      ? data?.club_address?.slice(0, 24) + "..."
                      : data?.club_address}
                  </p>
                  <div
                    className="table-new-card-text-section-location-distance"
                    onClick={() => openInGoogleMaps(data?.club_address)}>
                    <span>
                      <FaDirections /> {Math.round(data?.distance)} Kms
                    </span>
                  </div>
                </div>

                <>
                  <span className="table-new-card-pnats-icon-wrapper-adult-text">
                    Live event
                  </span>
                  <div className='time-onwards-bid-new-card carnivaltag'>
                    <div className='carnival-set'>
                      <p className='font-12'> <span>{data?.event_date}</span> <br /> {data?.event_time} Onwards</p>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="106" height="50" viewBox="0 0 106 50" fill="none">
                      <path d="M91.2722 4.46062C90.2252 1.77121 87.635 0 84.749 0H7C3.13401 0 -7.62939e-06 3.13401 -7.62939e-06 7V43C-7.62939e-06 46.866 3.134 50 6.99999 50H98.7633C103.688 50 107.073 45.0497 105.286 40.4606L91.2722 4.46062Z" fill="url(#paint0_linear_2209_1590)" />
                      <defs>
                        <linearGradient id="paint0_linear_2209_1590" x1="110.506" y1="48.9394" x2="-2.86794" y2="7.92836" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#7464E4" />
                          <stop offset="1" stop-color="#1A00D2" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </>
              </div>
              {/* <div>
                                <div className='pnats-icon-wrapper-icon-mobile' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div>
                            </div> */}
            </div>

            <div className="table-new-card-about-text-section">
              <div className="pnats-icon-wrapper">
                {/* <div className='pnats-icon-wrapper-icon-desktop' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div> */}
                {isFiltered && (
                  <div className="pnats-icon-wrapper-icon pnats-icon-wrapper-icon2">
                    <MdOutlineFilterAlt size={25} />
                    <div className="pnats-icon-wrapper-icon pnats-icon-wrapper-icon3">
                      <MdOutlinePushPin size={10} />
                    </div>
                  </div>
                )}
              </div>

              <span className="table-new-card-pnats-icon-wrapper-adult-text">
                Discount Offer
              </span>
              <div className="table-new-card-pnats-icon-wrapper-adult">

                <span className='table-new-card-tablediscount-box-wrap'>
                  <span className='table-new-card-tablediscount-overlay'>
                    <MdRestaurant />{" "} {data?.food_discount || 30}%{" "}off
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="109" height="34" viewBox="0 0 89 28" fill="none">
                    <path d="M9.74698 3.40078C11.0117 1.29106 13.291 0 15.7508 0H82C85.866 0 89 3.13401 89 7V21C89 24.866 85.866 28 82 28H7.35792C1.91804 28 -1.44293 22.0665 1.35412 17.4008L9.74698 3.40078Z" fill="#006D0D" />
                  </svg>
                </span>
                <span className='table-new-card-tablediscount-box-wrap'>
                  <span className='table-new-card-tablediscount-overlay'>
                    <BiSolidDrink />{" "} {data?.food_discount || 40}%{" "}off
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="109" height="34" viewBox="0 0 89 28" fill="none">
                    <path d="M9.74698 3.40078C11.0117 1.29106 13.291 0 15.7508 0H82C85.866 0 89 3.13401 89 7V21C89 24.866 85.866 28 82 28H7.35792C1.91804 28 -1.44293 22.0665 1.35412 17.4008L9.74698 3.40078Z" fill="#006D0D" />
                  </svg>
                </span>
              </div>

              <div className="Table-new-about-text-section">
                <h1>Features</h1>

                <div>
                  <ul className="PackageNewCard-about-text-section-list">
                    {Object.entries(data?.inclusion || {})
                      .filter(([key]) => !["package_name"].includes(key))
                      .slice(0, 2)
                      .map(([key, value], index) => (
                        <li key={index}>
                          {key.replace(/_/g, " ")}: {value}
                        </li>
                      ))}
                  </ul>
                </div>

                {Object.keys(data?.inclusion || {}).length > 2 && (
                  <p
                    onClick={(event) => {
                      event.stopPropagation();
                      setShowMoreModal(true);
                    }}
                  >
                    {Object.keys(data.inclusion).length - 4}+ More
                  </p>
                )}
              </div>


             
            </div>
          </div>

          <div className="w-100 d-flex flex-column justify-content-center gap-1">
            <Link
              to={`/bid-detail/${data?.club_slug}/${format(data?.title)}/${data?.id
                }`}
              style={{ textDecoration: "none", width: "100%" }}>
              <div className="table-new-card-text-section-button">
                <button className=" m-hide">View Details</button>
                <div className="table-new-card-break-line"></div>
                <div className="table-new-card-text-section-text-wrapper">
                  <TextRoller messages={messages} />
                </div>
              </div>
            </Link>
            <Link
              className="w-100 d-flex flex-column justify-content-center"
              to={`/bid-detail/${data?.club_slug}/${format(data?.title)}/${data?.id
                }`}
              style={{ textDecoration: "none", width: "100%" }}>
              <button className="btn text-btn d-hide">View Details</button>
            </Link>
          </div>
        </div>
      </div>

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentShareUrl}
        title={shareTitle}
      />
      <MoreFeatureShow
        isOpen={showMoreModal}
        onClose={() => setShowMoreModal(false)}
        title="Features"
        inclusions={data?.inclusion}
        isBid={true}
      />
    </>
  );
}
